"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _migrating = _interopRequireDefault(require("@/components/GlSteps/mixin/migrating"));
var _default = exports.default = {
  fiCommon: {
    query: '查询',
    reset: '重置',
    add: '新增',
    copy: '复制',
    export: '导出',
    save: '保存',
    submit: '提交至发送队列',
    cancel: '取消',
    operation: '操作',
    edit: '编辑',
    detail: '详情',
    delete: '删除',
    createReceipt: '批量生成万能单',
    lookImage: '查看影像',
    look: '查看',
    writeOff: '红冲',
    confirm: '确定',
    section: '切片',
    delSection: '删除切片',
    exportInOut: '导出出入库明细',
    exportEntry: '导出分录',
    unsend: '置为不发送',
    setRegistered: '置为登记',
    ywedit: '运维调整',
    downloadTemplate: '下载导入模板',
    importTemplate: '导入'
  },
  finance: {
    title: {
      financeManage: '业财管理',
      ruleConfig: '业财规则配置',
      fiReceiptSearch: '万能单据查询',
      fiReceiptManage: '万能单据管理',
      financeOrder: '定单业财步骤',
      receiptMonth: '业财库存统计',
      dockRepairSearch: '坞修统计查询',
      dataChangeMonitor: '交互数据查询',
      dataSendMonitor: '与业财集成平台',
      dataReceiveMonitor: '与内部模块',
      fiBizInOut: '库存动态',
      accountGroupManage: '核算项目组管理'
    },
    prompt: {
      saveSuccess: '保存成功',
      saveFaild: '保存失败',
      createSuccess: '生成成功',
      createFaild: '生成失败',
      submitAgain: '请勿重复提交',
      saveAgain: '请勿重复保存',
      createAgain: '请勿重复生成',
      deleteSuccess: '删除成功',
      deleteFaild: '删除失败',
      submitSuccess: '提交成功',
      submitFaild: '提交失败',
      operSuccess: '操作成功',
      operFaild: '操作失败',
      tip: '提示',
      yes: '是',
      no: '否',
      confirm: '确定',
      cancel: '取消',
      searchFaild: '查询失败'
    },
    filter: {
      manageCompany: '管理公司',
      vessel: '船舶',
      category: '品种',
      currency: '币种',
      vesselType: '船舶属性',
      busiType: '业务类型',
      supplier: '供应商',
      debitCredit: '借贷方向',
      module: '所属业务',
      operateType: '操作类型'
    },
    placeholder: {
      selectDate: '选择日期',
      selectYearMonth: '选择年月'
    },
    financePayment: {
      title: '预付\应付单集成管理',
      filter: '过滤器',
      keyWord: '关键字检索',
      rules: {
        pleaseEnterKeyWord: '请输入关键字'
      }
    },
    dock: {
      keyWord: '关键字检索',
      dataReinput: '数据回写',
      vesselName: '船舶名称',
      dockRepair: '坞修航次',
      dockStartDate: '坞修开始日期',
      dockEndDate: '坞修结束日期',
      business: '业务科目',
      currency: '币种',
      deferred: '待摊费用',
      dockRepairCost: '坞修成本',
      capitalization: '资本化',
      totalAmount: '总金额',
      conversion: '期末折算汇率',
      convertedCurrency: '折算本位币',
      receive: {
        receiveSuccess: '回写成功',
        receiveFaild: '回写失败',
        receiveData: '回写数据',
        receive: '回写',
        receiveContent: '回写报文',
        pleaseInputReceiveMessage: '请输入返回的信息'
      },
      filter: {
        vesselName: '船名',
        applyDate: '申领日期'
      },
      rules: {
        pleaseEnterKeyWord: '请输入关键字'
      }
    },
    inventory: {
      searchSection: '查询区间',
      amountInOriginal: '原币金额',
      selectDate: '选择年月',
      searchFaild: '搜索失败',
      deleteMouth: '确定要删除本月切片数据吗？',
      nonMouthGenerate: '本月未生成切片数据',
      hint: '提示',
      yes: '是',
      no: '否',
      deleteSuccess: '删除成功',
      deleteFaild: '删除失败',
      generateData: '切片数据生成中...',
      rules: {
        pleaseSelectCompany: '请选择管理公司',
        pleaseSelectGenerateCompany: '请选择要切片的公司'
      }
    }
  },
  ruleConfig: {
    title: '规则配置',
    detail: '配置详细信息',
    table: {
      vesselCode: '船名',
      debit: '借方',
      credit: '贷方',
      HKWShippingCO: '香港明华船务有限公司',
      HKWManageCo: '香港明华船舶管理有限公司'
    },
    query: {
      sceneCode: '场景编码',
      feeCode: '费用科目编码',
      companyName: '所属公司',
      all: '是否包含失效规则'
    },
    form: {
      companyName: '所属公司',
      chargeName: '业务科目',
      vesselType: '船舶属性',
      accountType: '记账模式',
      businessName: '具体业务',
      operateType: '操作类型',
      accountSet: '账套',
      debitCredit: '借贷方向',
      debitCode: '借方科目',
      debitName: '借方名称',
      debitFeeCode: '借方费用类型编码',
      creditCode: '贷方科目',
      creditName: '贷方名称',
      creditFeeCode: '贷方费用类型编码',
      accountGroup: '核算项目',
      sceneCode: '场景编码',
      sceneName: '场景名称',
      version: '版本号',
      startTime: '启用时间',
      endTime: '停用时间',
      remark: '备注'
    },
    prompt: {
      pleaseInput: '请输入',
      acquisitionFailure: '获取失败',
      saveSuccess: '保存成功',
      saveFalse: '保存失败',
      chargeNotNull: '请选择业务科目',
      vesselTypeNotNull: '请选择船舶属性',
      accountTypeNotNull: '请选择记账模式',
      businessTypeIdNotNull: '请选择具体业务',
      operateTypeNotNull: '请选择操作类型',
      accountSetNotNull: '请选择账套',
      debitCreditFlagNotNull: '请选择借贷方向',
      debitCodeNotNull: '请填写借方科目',
      creditCodeNotNull: '请填写贷方科目',
      selectCompanyAdd: '请选择管理公司后再点击新增',
      projectNotNull: '请选择核算项目',
      vesselNotNull: '请选择船舶',
      deptNotNull: '请选择部门',
      easDeptNotNull: '请填写EAS部门代码',
      startTime: '请输入启用时间',
      tips: '提示',
      confirmMsg: '确定',
      cancelMsg: '取消',
      confirmSub: '是否确认提交该记录',
      deleteTip: '是否确认删除该记录',
      deleteSuc: '删除成功',
      deleteFail: '删除失败',
      candelDel: '已取消删除',
      rules: {
        pleaseSelectCopyData: '请选择要复制的数据'
      },
      dialog: {
        getFaild: '获取失败'
      }
    }
  },
  receiptInfo: {
    receiptDetail: '万能单据详细信息',
    generateReceipt: '生成万能单据',
    writeOffReceipt: '红冲分录',
    receiptAccount: '核算项目',
    receiptInOut: '出入库记录',
    orderReceipt: '定单暂估冲销信息',
    baseInfo: '基本信息',
    btn: {
      add: '新增'
    },
    tip: {
      select: '请选择分录明细进行操作',
      adjustment: '只有处于[登记、待核查、发送失败]状态才能进行运维调整',
      limit: '只能选择一条数据进行运维调整'
    },
    query: {
      busiCode: '业务单号',
      origCode: '原单编码',
      accountDate: '记账日期',
      sceneCode: '场景',
      accountYearMonth: '会计期间',
      companyCode: '公司产权码',
      orderNo: '定单号',
      feeCode: '费用科目编码',
      voucherNo: '凭证号'
    },
    tab: {
      all: '全部',
      register: '登记',
      waitSend: '待发送',
      sended: '已发送',
      sendSuccess: '发送成功',
      sendFail: '发送失败',
      noSend: '不发送'
    },
    form: (0, _defineProperty2.default)({
      vesselCode: '船舶代码',
      receiptCode: '原单编码',
      vesselName: '船舶名称',
      companyCode: '公司产权码',
      accountDate: '记账日期',
      sceneCode: '场景编码',
      voucherNo: '凭证号',
      businessInvoiceDate: '业务日期/发票日期',
      businessDate: '业务日期',
      sceneName: '场景名称',
      sendStatus: '发送状态',
      accountYearMonth: '会计期间',
      imageCode: '影像编码',
      receiptRemark: '摘要',
      staEndTime: '统计截止日期',
      selectDate: '选择日期',
      createTime: '创建时间',
      debitFeeCode: '借方科目',
      creditFeeCode: '贷方科目',
      debitFeeName: '借方科目名称',
      creditFeeName: '贷方科目名称'
    }, "voucherNo", '保存凭证号'),
    prompt: {
      writeOffSuccess: '红冲成功',
      writeOffFaild: '红冲失败',
      getFaild: '获取失败',
      generattingReceipt: '万能单据生成中...',
      pleaseSelectGenerateCompany: '请选择要生成万能单据的公司',
      selectCompany: '请选择管理公司',
      confirmSubmit: '提交后发送成功的万能单不能修改,确定要提交所选择的数据至发送队列吗？',
      selectRegister: '请选择登记状态的数据执行此操作',
      selectSetRegister: '请选择不发送状态的数据执行此操作',
      selectRegOrNosend: '请选择登记或不发送或发送失败状态的数据提交',
      selectSubmitData: '请选择要提交的数据',
      confirmDelete: '是否确认删除该记录',
      dataDelete: '只有登记或不发送状态的数据可以删除',
      cancelDelete: '已取消删除',
      selectItem: '请选择分录数据，再生成红冲数据！',
      selectReceipt: '请选择万能单据主信息',
      unsendReceipt: '确定要将选择的数据置为[待核查]状态吗？',
      setRegistered: '确定要将选择的数据置为[登记]状态吗？',
      selectOperData: '请选择要操作的数据',
      editUnSend: '只能对不发送状态的数据进行运维调整',
      selectedList: '请选择不发送的万能单据进行操作',
      rules: {
        remarkNotNull: '备注信息不能为空'
      },
      order: {
        Estimate: '暂估',
        Consume: '消耗',
        Invoice: '发票',
        RedDashed: '发票红冲',
        EstimatedWriteOff: '暂估冲销',
        searchFaild: '搜索失败',
        parts: '备件',
        fuel: '物料',
        trans: '调拨单',
        afterPay: '付款后签收',
        newShip: '新造船'
      }
    }
  },
  receiptItem: {
    title: '分录明细',
    form: {
      vesselCode: '船舶代码',
      vesselName: '船舶名称',
      supplierCode: '供应商航筹办代码',
      supplierName: '供应商名称',
      orderNo: '定单号',
      categoryCode: '品种编码',
      businessCode: '业务科目',
      categoryName: '品种名称',
      debitCredit: '借贷方向',
      debitFeeCode: '借方科目',
      creditFeeCode: '贷方科目',
      originalAmount: '原币金额',
      currency: '币种',
      rate: '汇率',
      localCurrencyAmount: '本位币金额',
      projectNum: '在建工程号',
      businessNo: '业务单号',
      itemSummary: '分录摘要'
    },
    inOutForm: {
      control: '是否受控',
      vesselName: '船舶名称',
      orderNo: '定单号',
      materialName: '物资名称',
      inOrOut: '出库/入库',
      inOutType: '出入库类型',
      inOutDate: '出入库日期',
      quantity: '数量',
      price: '本次参与计算单价',
      totalAmount: '总价',
      orderPrice: '定单单价',
      discount: '折扣%',
      invoicePrice: '发票单价',
      discountUnit: '定单折后单价',
      currency: '币种',
      rate: '汇率',
      chargeName: '业务科目',
      displayOrder: '顺序码'
    },
    order: {
      index: '序号',
      estimate: '暂估金额',
      reverse: '冲销金额',
      noreverse: '剩余冲销金额',
      reversalAmount: '本次冲销金额',
      reversalBalance: '本次冲销后余额'
    },
    receiptDetail: {
      countTotal: '总价合计'
    },
    prompt: {
      searchFaild: '搜索失败',
      getFaild: '获取失败'
    }
  },
  receiptAccount: {
    form: {
      accountType: '核算项目类型',
      accountTypeName: '核算项目类型名称',
      accountCode: '核算项目编码',
      accountName: '核算项目名称'
    }
  },
  receiptMonth: {
    inventoryDetail: '凭证分录明细',
    title: {
      section: '切片'
    },
    form: {
      endAmountLocal: '期末本位币',
      vesselName: '船舶代码-船舶名称',
      categoryName: '品种代码-品种名称',
      currency: '币种',
      startAmount: '期初余额',
      nowAddPayment: '当期新增（AP单据)',
      nowAddReceipt: '当期新增（万能单据)',
      nowReduce: '当期消耗',
      endAmount: '期末结余',
      oraginalAmount: '原币金额',
      localAmount: '本位币金额',
      endRate: '期末汇率',
      openAmountLocal: '存量财务折算本位币'
    },
    detail: {
      receiptCode: '原单编码',
      monthType: '分类归纳',
      accountDate: '记账日期',
      orderNo: '定单号',
      currency: '币种',
      rate: '汇率',
      oriAmount: '原币金额',
      localAmount: '本位币金额',
      memo: '备注',
      startAmount: '期初原币',
      startAmountLocal: '期初本位币',
      betweenAmount: '区间汇总原币',
      betweenAmountLocal: '区间汇总本位币',
      endAmount: '期末原币',
      endAmountLocal: '期末本位币'
    },
    prompt: {
      getFaild: '获取失败'
    },
    sectionDate: '切片日期'
  },
  fiDictionary: {
    groupTitle: '核算项目组配置',
    groupDetail: '配置详细信息',
    groupForm: {
      dispOrder: '顺序号',
      accountGroup: '核算项目'
    },
    query: {
      charge: '业务科目',
      category: '品种代码/名称',
      department: '部门代码/名称',
      easDept: 'EAS部门代码'
    },
    configTitle: '业务科目品种映射',
    configForm: {
      categoryCode: '品种代码',
      categoryName: '品种名称',
      chargeId: '业务科目',
      chargeCode: '业务科目代码',
      chargeNameCn: '业务科目中文名称',
      chargeNameEn: '业务科目英文名称',
      dispOrder: '顺序号',
      module: '所属业务',
      vessel: '船舶',
      department: '部门',
      vesselNameCn: '船舶中文名称',
      vesselNameEn: '船舶英文名称',
      deptCode: '部门代码',
      deptNameCn: '部门中文名称',
      deptNameEn: '部门英文名称',
      easDeptCode: 'EAS部门代码'
    },
    from: {
      pleaseSelect: '请选择'
    },
    prompt: {
      categoryCodeNotNull: '请输入品种代码',
      getFaild: '获取失败',
      tips: '提示',
      confirmMsg: '确定',
      cancelMsg: '取消',
      confirmSub: '是否确认提交该记录',
      deleteTip: '是否确认删除该记录',
      deleteSuc: '删除成功',
      deleteFail: '删除失败',
      candelDel: '已取消删除'
    }
  },
  dataMonitor: {
    query: {
      busiCode: '业务单号',
      origCode: '原单编码',
      interfaceName: '接口名称',
      receiveContent: '接收内容',
      receiveTime: '接收时间',
      sendTime: '发送时间'
    },
    form: {
      busiType: '业务类型',
      busiCode: '业务单号',
      origCode: '原单编码',
      sendContent: '发送内容',
      sendTime: '发送时间',
      sendCount: '发送次数',
      responseInfo: '响应信息',
      responseTime: '响应时间',
      sendStatus: '发送状态',
      errorMessage: '错误信息',
      interfaceName: '接口名称',
      receiveTime: '接收时间',
      receiveContent: '接收内容',
      returnContent: '返回内容',
      receiveFlag: '接收状态'
    },
    tab: {
      all: '全部',
      recSuccess: '接收成功',
      recFaild: '接收失败',
      sendSuccess: '发送成功',
      sendFail: '发送失败',
      waitSend: '待发送',
      sended: '已发送',
      noSend: '不发送'
    },
    prompt: {
      toBeSend: '待发送',
      sent: '已发送',
      sendSuccess: '发送成功',
      sendFaild: '发送失败',
      searchFaild: '搜索失败',
      getFaild: '获取失败',
      receiveFailed: '接受失败',
      receiveSuccess: '接收成功',
      rules: {
        pleaseSelectSearchData: '请选择要查看的数据'
      }
    }
  },
  safetyProductCost: {
    safetyFlag: '包含安全生产费',
    addTips: '新增成功',
    dialogTitleName: '安全生产费复核',
    titleName: '结算中心',
    minTitleName: '安全生产费管理',
    draft: '草稿',
    toSubmitted: '待提交',
    reviewing: '复核中',
    reviewed: '复核通过',
    normalOrder: '正常定单',
    cancelOrder: '定单已取消',
    confirmation: '账单确认',
    spare: '备件',
    material: '物料',
    repairShip: '修船',
    survey: '检验',
    test: '检验',
    signedNot: '船端未签收',
    partial: '签收中',
    signeded: '签收完成',
    dialogTips: '包含安全生产费不能为空',
    dialogTips1: '汇总列表数据至少需要有一条',
    dialogTips2: '项目列表中需选中至少一个安全生产费！',
    checkSafeFlag: '请选择安全生产费分类',
    selectList: {
      moduleFlag: '定单类型',
      moduleFlagO: '备件',
      moduleFlagTW: '物料',
      moduleFlagTH: '修船',
      moduleFlagF: '检验'
    },
    table: {
      orderNo: '定单号',
      vesselName: '船名',
      orderDate: '下单日期',
      completeDate: '签收/完工日期',
      payConfirmDate: '账单确认日期',
      auditDate: '复核日期',
      receiptDate: '生成凭证日期',
      chargeName: '业务科目',
      module: '定单类型',
      supplierName: '供应商',
      currency: '原币币种',
      currencyLocal: '本位币币种',
      rate: '汇率',
      orderAmount: '定单总金额(原币)',
      orderAmountLocal: '定单总金额(本位币)',
      safetyAmount: '安全生产费金额(原币)',
      safetyAmountLocal: '安全生产费金额(本位币)',
      orderStatus: '定单状态',
      reviewStatus: '复核状态',
      submitMen: '提交人',
      sumitDate: '提交日期'
    },
    dialog: {
      info: '基本信息',
      vesselName: '船名',
      orderNo: '定单号',
      orderStatus: '定单状态',
      signStatus: '签收状态',
      module: '定单类型',
      supplierName: '供应商',
      orderAmount: '定单折后总金额',
      currency: '币种',
      safetyAmount: '安全生产费总金额',
      reviewStatus: '安全生产费复核状态',
      safetyFlag: '包含安全生产费',
      yes: '是',
      no: '否',
      safetyChargeId: '安全生产费分类',
      subtotalsName: '安全生产费分类汇总信息',
      auditAmount: '预估金额',
      actualAmount: '实际金额',
      itemInfo: '项目明细',
      itemNo: '项目编号',
      itemName: '项目名称',
      itemQuantity: '数量',
      itemUnit: '单位',
      itemUnitPrice: '单价',
      discount: '折扣',
      amount: '折后金额',
      hasSafetyFlag: '包含安全生产费',
      discountUnitPrice: '折后单价',
      discountAmount: '折后总金额',
      totoalAuditAmount: '总预估金额',
      totoalActualAmount: '总实际金额',
      taxRate: '定单税率'
    }
  },
  safetyProductCostStatistics: {
    queryTips: '下单日期范围不能跨年,请重新选择',
    percentage: '时间进度百分比',
    accruedAmount: '计提(预算)总金额',
    actualAmount: '实际总金额占计提(预算)总金额百分比',
    totalAmountLocal: '本位币实际总金额',
    title: '安全生产费统计',
    orderType: '定单类型',
    survey: '检验',
    safetyType: '安全生产费分类',
    applyStartDate: '下单起始日期',
    applyEndDate: '下单截止日期',
    originalAmount: '原币金额',
    localAmount: '本位币金额'
  }
};